/*!
 * Built by Revolist OU ❤️
 */
import './index-f6fae858.js';

const globalFn = () => { };

const globalScripts = globalFn;

export { globalScripts as g };

//# sourceMappingURL=app-globals-6b929fd8.js.map